import { ContractorApiListSharedType } from '../../types';

type SharedRecipient = ContractorApiListSharedType['listRecipient'][number];

export const getRecipientContact = (recipient: SharedRecipient) =>
    [recipient.name || recipient.fullName, recipient.email, recipient.phone].filter(Boolean).join(', ') || recipient.id;
